import { Record } from 'immutable';
import remove from 'lodash/fp/remove';
import * as types from './actionTypes';
import constants from '../constants';

const requestReducerState = Record({
  dealers: [],
  dealer: {
    id: null,
  },
  tmpDealer: {},
  makes: [],
  step: 0, // a counter of what step is active in the ui
  ymmt: { years: [] },
  dealerPriceRules: null,
  [constants.ERROR_KEY]: null,
  [constants.SUCCESS_KEY]: null,
  [constants.FETCHING_KEY]: false,
});

export default (state = requestReducerState(), action) => {
  const { type, payload } = action;
  switch (type) {
    case types.DEALERS_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('dealers', payload);
    case types.MODIFY_DEALER_TMP_STATE_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('tmpDealer', payload.tmpDealer);
    case types.INVENTORY_IMPORT_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(
          constants.SUCCESS_KEY,
          'Dealer inventory import has started - current progress can checked at the Import Status column',
        )
        .set(constants.FETCHING_KEY, false);
    case types.DEALER_STATUS_SUCCESS: {
      const newDealers = state.dealers.map((d) =>
        d.id === payload.id ? payload : d,
      );
      return state
        .set('dealers', newDealers)
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, false);
    }
    case types.DEALER_SUCCESS:
    case types.CREATE_DEALER_SUCCESS:
    case types.UPDATE_DEALER_SUCCESS: {
      const feeds = payload.Feeds ? payload.Feeds.map((f) => f.id) : undefined;
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('dealer', { ...payload, feeds });
    }
    case types.DELETE_DEALER_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('dealers', remove({ id: payload })(state.dealers));
    case types.DEALER_YMMT_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('ymmt', action.payload);
    case types.DEALER_PRICE_RULES_UPDATE_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, false);
    case types.DEALERS_REQUEST:
    case types.DEALER_REQUEST:
    case types.DEALER_STATUS_REQUEST:
    case types.CREATE_DEALER_REQUEST:
    case types.UPDATE_DEALER_REQUEST:
    case types.DELETE_DEALER_REQUEST:
    case types.INVENTORY_IMPORT_REQUEST:
    case types.DEALER_YMMT_REQUEST:
    case types.DEALER_PRICE_RULES_UPDATE_REQUEST:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, true);
    case types.DEALERS_FAILURE:
    case types.DEALER_FAILURE:
    case types.DEALER_STATUS_FAILURE:
    case types.CREATE_DEALER_FAILURE:
    case types.UPDATE_DEALER_FAILURE:
    case types.DELETE_DEALER_FAILURE:
    case types.INVENTORY_IMPORT_FAILURE:
    case types.DEALER_YMMT_FAILURE:
    case types.DEALER_PRICE_RULES_UPDATE_FAILURE:
      return state
        .set(constants.FETCHING_KEY, false)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.ERROR_KEY, action.payload);
    case types.DEALER_PRICE_RULES_FETCH_SUCCESS:
      return state.set('dealerPriceRules', action.payload);
    case types.DEALER_PRICE_RULES_FETCH_FAILURE:
      return state.set('dealerPriceRules', null);
    case types.RESET_DEALER:
      return state.set('dealer', requestReducerState().dealer);
    case types.SET_DEALER_THEME_REQUEST: {
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, true);
    }
    case types.SET_DEALER_THEME_SUCCESS: {
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, true)
        .set(constants.FETCHING_KEY, false)
        .set('dealer', { ...payload });
    }
    case types.SET_DEALER_THEME_FAILURE:
      return state
        .set('dealer', state.dealer)
        .set(constants.ERROR_KEY, payload)
        .set(constants.FETCHING_KEY, false);
    default:
      return state;
  }
};
